import React from 'react'

export default class IconLogoInmotion extends React.Component {

    render() {
        let color = "#C8C5FE";
        if (this.props.color) color = this.props.color;
        let className = "icons-icon";

        return <svg className={className} style={this.props.style} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <g clipPath="url(#clip0_1323_28241)">
                <rect width="24" height="24" rx="6" fill="white" />
                <path d="M3.05664 9.92337L23.8989 9.91211L23.4565 12.0637L3.05664 9.92337Z" fill="#C32227" />
                <path d="M-0.101562 10.2188L23.2397 12.7785L22.8255 14.6653L-0.101562 10.2188Z" fill="#C32227" />
            </g>
            <defs>
                <clipPath id="clip0_1323_28241">
                    <rect width="24" height="24" rx="6" fill="white" />
                </clipPath>
            </defs>
        </svg>
    }
}    
